export var ExperimentConfig = {
    RBExperimentProduction: {
        flagKey: 'rb-experiment-production',
        variants: ['control', 'treatment'],
    },
    // DEAP-3695: gates the top "Other designs you might like" (offsite) swimlane on
    // the PDP. Defaults to off (no enrolment) so the swimlane is hidden for everyone;
    // the `control` variant re-shows it (the intact above-the-fold experience).
    OffsiteSimilarDesigns: {
        flagKey: 'rb-offsite-similar-designs-pdp',
        variants: ['control', 'treatment'],
    },
    CartTrayExpressPayments: {
        flagKey: 'rb-cart-tray-express-payments',
        variants: ['control', 'variant'],
    },
};
export var AMPLITUDE_OFF_ENROLMENT = 'off';
